import { ApiMethodDeclaration } from '..';

type ParamsData = undefined;

type ResponseData = any;

export const removeAllMissing: ApiMethodDeclaration<ParamsData, ResponseData> = () => ({
    url: '/missing-translations/remove',
    method: 'DELETE',
});
